import { render, staticRenderFns } from "./MissionManagementDetails.vue?vue&type=template&id=87b53cd6&scoped=true&"
import script from "./MissionManagementDetails.vue?vue&type=script&lang=js&"
export * from "./MissionManagementDetails.vue?vue&type=script&lang=js&"
import style0 from "./MissionManagementDetails.vue?vue&type=style&index=0&id=87b53cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b53cd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDataTable,VDialog,VRow,VSpacer})
